import React from 'react';

const BurgerHint = () => {
  return (
    <p style={{ fontSize: '0.9rem', marginTop: '0.5em', color: '#6b7280', textAlign: 'center' }}>
      🍔 Use the menu at the top-left to visit other pages or bottom navigation on info pages.<br />
      📱 On iPhone? Tap Share → Add to Home Screen in Safari to install dAIsy like a real app.
    </p>
  );
};

export default BurgerHint;
